import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Personal from './components/Personal';
import Skills from './components/Skills';
import Experiences from './components/Experiences';
import Education from './components/Education';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Personal />
        <Skills />
        <Experiences />
        <Education />
      </main>
      <Contact />
    </div>
  );
}

export default App;
